import { Link } from "react-router-dom";
import { Logo } from "./Logo";

export const PageHeader = () => (
  <header className="fixed top-0 inset-x-0 z-50 border-b border-white/[0.08] bg-[#0A0B0E]/80 backdrop-blur-xl" data-testid="page-header">
    <div className="mx-auto max-w-7xl px-5 sm:px-8 h-16 flex items-center justify-between">
      <Link to="/" data-testid="page-logo-link" aria-label="UrgentSellBuy home"><Logo /></Link>
      <Link to="/support" data-testid="page-header-support-link" className="text-sm text-zinc-300 hover:text-white transition-colors">Help & Support</Link>
    </div>
  </header>
);
